<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
    			<!-- <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"> -->
            <div class="md-layout-item">                
                <div class="card">
                    <div class="card-body">
                        <h3>設定密碼</h3>                        
                        <label title="New Password">請輸入密碼以完成登入，密碼長度至少8個字元，需為英文與數字或符號混合</label>
                          <br><b></b>
                          <div class="form-group pass_show"> 
                             <input type="password" class="form-control" name="password" v-bind:class="{ 'is-invalid': passwordError }" v-model="password"
                                  placeholder="請輸入密碼"><div class="prompt"></div>
                              <div v-show="passwordError" class="errMsg">
                                  {{ passErrMsg }}
                              </div>
                          </div> 
                        <label title="Confirm Password">確認密碼</label>
                          <div class="form-group pass_show"> 
                              <input type="password" class="form-control" name="passCheck" v-bind:class="{ 'is-invalid': passwordError }" v-model="passCheck" placeholder="請再次輸入密碼">
                              <div v-show="passwordError" class="errMsg">
                                  {{ passCheckErrMsg }}
                              </div>
                          </div>
                          <div class="form-group">
                            <button title="Send" @click="send" :disabled="passwordError">送出</button>
                          </div>
                    </div>
                </div>
            </div>            
        </div>
      </div>
    </parallax>    
  </div>
</template>

<script src="https://code.jquery.com/jquery-3.3.1.min.js" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.6/umd/popper.min.js" integrity="sha384-wHAiFfRlMFy6i5SRaxvfOCifBUQy1xHdJ/yoi7FRNXMRBu5WHdZYu1hA6ZOblgut" crossorigin="anonymous"></script>
<script>
//import { constants } from 'crypto';
//import axios from 'axios'
export default {
  bodyClass: "profile-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/0040020-PS2.jpg")
    },
    app_store: {
      type: String,
      default: require("@/assets/img/logo/app_store2x.png")
    },
    google_play: {
      type: String,
      default: require("@/assets/img/logo/google_play2x.png")
    }
  },
  data() {
    return {
        password: '',
        passwordError: true,
        passErrMsg: '',
        passCheck: '',        
        passCheckErrMsg: '',
        key:''        
    };
  },
  methods: {
    send() {
      let vm = this;      
       
       if(this.passCheck.length>0 && !this.passCheckError )
      {        
        let key = vm.key
        vm.$http.get('User/VerifyKey/?key='+encodeURIComponent(vm.key))
        .then(function (res) {
          if(res.data.result)
          {
            let user = res.data.guid
            let password = vm.password
            vm.$http.post('User/SetPassword/',{user,password}).then(function(res){
              if(res.data.result)
              {
                alert('設定成功')
                vm.$router.push({ path: 'setpassword_finish' })
              }              
            }).catch(function (error) {
              let errors = error.response.data.errors;
                if(errors[0].errorCode=='00018')
                {
                  alert('使用者已設定密碼')
                }
                else if(errors[0].errorCode=='00013')
                  alert('使用者不存在')
                  else
               alert(JSON.stringify(error.response.data));
            });
          }          
        })
        .catch(function (error) {                    
             if(error.response.data.errors[0].errorCode=='00010')
               alert('驗證碼資料錯誤')
             else if(error.response.data.errors[0].errorCode=='00011')
               alert('驗證碼過期')
             else
               alert(JSON.stringify(error.response.data));
        });
      }
      else{
        alert('請輸入密碼')
      }
    },
  checkPasswrod(){
      var reg = /^(?=.*[a-zA-Z].*)(?=.*\\d.*|.*).{8,}$/
        this.passwordError = false;        
        this.passCheckErrMsg = '';
        this.passErrMsg = '';
        if(this.password.length <8)
        {
            this.passwordError = true;
            this.passErrMsg = '密碼長度至少8個字元';
            return;
        }
        if (!reg.test(this.password)) {
            this.passwordError = true;
            this.passErrMsg = '密碼需為英文與數字或符號混合'
            return;
        }            
        if( this.passCheck.length == this.password.length)
        {
          if (this.password!= this.passCheck) {
            this.passwordError = true;
            this.passCheckErrMsg = '密碼不相符1';
            return;
          }
        }
        else{
          this.passwordError = true;
          this.passCheckErrMsg = '密碼不相符';
          return;
        }
    }
  },
 watch: {        
        password: {handler:'checkPasswrod'},
        passCheck: {handler:'checkPasswrod'}
    },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
          //background: ` url(${this.header}) center center`
      };
    }    
  },
  created() {      
      this.key = this.$route.query["key"]      
  }
};


</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
h2{
  margin: 0 0 8px 0;
  line-height: 1em
}
h4{
  margin: 0 0   30px 0;
}
.container
{
  color: rgb(74,74,74) !important
}
a img{
  height: 40px;
}
.card{
    text-align: center;    
    width: 100%;      
}
.card-body{
    background-color: #f7f7f7;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    padding: 18px 20px;
    border-bottom: 1px solid #aaa;    
    box-sizing: border-box;
    width: 20rem;
    margin: auto; 
}
.card-body b{
  font-size: 0.75em;
}
.card-body label{
  padding: 5px;
  font-size: 0.9em;
  line-height: 1.2em;
}
.form-group{
  margin: 10px
}
.errMsg
{
  color: brown;
}
</style>
